<script>
// "Herança" direta, mantendo a estrutura isolada (arquivos)
import CurrencyField from "src/components/desktop/currency-field.vue";
export default CurrencyField;
</script>
